import React, { memo, useCallback, useLayoutEffect, useContext, useRef } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

export const FocusContext = React.createContext({
  focusElement: _.noop,
  suscribeFocusElement: _.noop,
});


export const FocusContextProvider = memo((props) => {
  const elements = useRef({}).current;

  const focusElement = useCallback(({ scenario }) => {
    if (elements[scenario] && elements[scenario].current) {
      elements[scenario].current.focus();
    }
  }, [elements]);

  const suscribeFocusElement = useCallback(({ scenario, componentRef }) => {
    if (componentRef && scenario) {
      elements[scenario] = componentRef;
    } else if (scenario) {
      delete elements[scenario];
    }
  }, [elements]);

  return (
    <FocusContext.Provider
      value={{
        suscribeFocusElement, focusElement,
      }}
    >
      {props.children}

    </FocusContext.Provider>
  );
});

FocusContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useNotifyFocus = ({
  scenario,
  trigger,
}) => {
  const { focusElement } = useContext(FocusContext);

  useLayoutEffect(() => {
    focusElement({ scenario });
  }, [focusElement, scenario, trigger]);
};

export const useAttachFocus = ({ scenario, componentRef }) => {
  const { suscribeFocusElement } = useContext(FocusContext);
  useLayoutEffect(() => {
    suscribeFocusElement({ scenario, componentRef });
    return () => {
      suscribeFocusElement({ scenario, componentRef: null });
    };
  }, [componentRef, scenario, suscribeFocusElement]);
};
